<template>
    <section class="component register send-options bg-white shadow-card rounded-lg p-8 mb-6">
        <header class="pt-2 pb-4 text-center">
            <h2 class="font-bold text-2xl md:text-3xl leading-none">Opsturen of brengen?</h2>
        </header>

        <div class="send-options sm:flex">
            <div @click="setSelectedSendOption('send')" class="send-options__item sm:w-1/2 sm:mr-4 py-6 px-8 rounded-lg cursor-pointer" :class="{ 'active': selectedSendOption === 'send' }">
                <div class="flex items-center">
                    <svg v-if="selectedSendOption === 'send'" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="14.5" stroke="#BDBDBD"/><circle cx="15" cy="15" r="11" fill="#43a100"/></svg>
                    <svg v-else width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="14.5" stroke="#BDBDBD"/></svg>

                    <span class="label ml-2 text-lg md:text-xl font-semibold">Opsturen</span>
                </div>

                <span class="block mt-3">Brengen bij een PostNL locatie</span>
            </div>

            <div @click="setSelectedSendOption('bring')" class="send-options__item sm:w-1/2 sm:mr-4 py-6 px-8 rounded-lg cursor-pointer" :class="{ 'active': selectedSendOption === 'bring' }">
                <div class="flex items-center">
                    <svg v-if="selectedSendOption === 'bring'" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="14.5" stroke="#BDBDBD"/><circle cx="15" cy="15" r="11" fill="#43a100"/></svg>
                    <svg v-else width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="14.5" stroke="#BDBDBD"/></svg>

                    <span class="label ml-2 text-lg md:text-xl font-semibold">Zelf brengen</span>
                </div>

                <span class="block mt-3">In Heerenveen</span>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    computed: {
        selectedSendOption() {
            return this.$store.state.registrationForm.delivery_method;
        }
    },

    methods: {
        setSelectedSendOption(value) {
            this.$store.commit('SET_REGISTRATION_FIELD', {
                property: 'delivery_method',
                value
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.component.register.send-options {

    .send-options {

        &__item {
            border: 1px solid #F2F2F2;

            .label {
                color: #828282;
            }

            &.active {
                .label {
                    color: #333333;
                }
            }
        }
    }
}
</style>
